// extracted by mini-css-extract-plugin
export default {"container":"Auth_container__1M6h8","navigate":"Auth_navigate__Z0NCo","breathing":"Auth_breathing__P-LDR"};